import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchParams: {
    pickupLocation: null, // { id, location_name, address, city, country_code }
    dropoffLocation: null,
    pickupDate: "",
    pickupTime: "10:00",
    dropoffDate: "",
    dropoffTime: "10:00",
    driverAge: "30",
    countryRes: "IN",
    currency: "INR",
  },
  locations: [], // full location list from /cars/locations
  isSearching: false, // true while /cars/search is in flight
  results: null, // { session_id, count, cars }
  selectedCar: null, // { session_id, reference_id, car_details }
  details: null, // /cars/details response
  insurancePlans: [], // /cars/insurance response
  selectedInsurance: null,
  bookingContext: null, // { session_id, reference_id, pax_details, no_of_passenger }
  confirmation: null, // /cars/book response
};

const carRentalSearchSlice = createSlice({
  name: "carRentalSearch",
  initialState,
  reducers: {
    setCarSearchParams: (state, action) => {
      Object.assign(state.searchParams, action.payload);
    },
    setCarLocations: (state, action) => {
      state.locations = action.payload;
    },
    setCarSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    setCarResults: (state, action) => {
      state.results = action.payload;
    },
    setSelectedCar: (state, action) => {
      state.selectedCar = action.payload;
      state.details = null;
      state.insurancePlans = [];
      state.selectedInsurance = null;
    },
    setCarDetails: (state, action) => {
      state.details = action.payload;
    },
    setCarInsurancePlans: (state, action) => {
      state.insurancePlans = action.payload;
    },
    setSelectedInsurance: (state, action) => {
      state.selectedInsurance = action.payload;
    },
    setCarBookingContext: (state, action) => {
      state.bookingContext = action.payload;
    },
    setCarConfirmation: (state, action) => {
      state.confirmation = action.payload;
    },
    resetCarRentalSearch: () => initialState,
  },
});

export const {
  setCarSearchParams,
  setCarLocations,
  setCarSearching,
  setCarResults,
  setSelectedCar,
  setCarDetails,
  setCarInsurancePlans,
  setSelectedInsurance,
  setCarBookingContext,
  setCarConfirmation,
  resetCarRentalSearch,
} = carRentalSearchSlice.actions;

export default carRentalSearchSlice.reducer;
